let config = {
    share : {
        url: "www.rehabmart.com/whyamisodizzy",
        title: 'Dizziness Rehabmart'
    }
}

export default config;

